import { render, staticRenderFns } from "./TipoSelect.vue?vue&type=template&id=10828dd0"
import script from "./TipoSelect.vue?vue&type=script&lang=js"
export * from "./TipoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports